// Number formats shared by the save analyzers (see docs/game-tools-ui.md).

/** One decimal place, as a string ("42.5"); 0 when there's nothing to count. */
export function percent(done, total) {
  return (total ? (done / total) * 100 : 0).toFixed(1)
}

export function fraction(have, total) {
  return `${have} / ${total}`
}
